import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../shared/services/api.service';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  standalone: false,
  styleUrls: ['./mfa.component.scss']
})
export class MfaComponent implements OnInit {

  isLoading: boolean = true;
  isMfaEnabled: boolean = false;
  
  setupDetails: { secret: string, qrCode: string } | null = null;
  otp: string = '';
  errorMessage: string | null = null;

  private currentUserEmail: string = '';

  constructor(
    private apiService: ApiService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    const user = this.authService.getUser();
    if (user && user.email) {
      this.currentUserEmail = user.email;
      this.checkMfaStatus();
    } else {
      this.errorMessage = 'Could not identify current user.';
      this.isLoading = false;
    }
  }

  checkMfaStatus(): void {
    this.isLoading = true;
    this.apiService.postData('/partners/auth/totp-mfa/status', { email: this.currentUserEmail }).subscribe(res => {
      if (res && !res.error) {
        this.isMfaEnabled = res.data.isMfaEnabled;
      }
      this.isLoading = false;
    }, () => {
      this.errorMessage = 'Failed to fetch MFA status.';
      this.isLoading = false;
    });
  }

  initiateMfaSetup(): void {
    this.errorMessage = null;
    this.apiService.postData('/partners/auth/totp-mfa/setup', { email: this.currentUserEmail }).subscribe(res => {
      if (res && !res.error) {
        this.setupDetails = res.data;
      } else {
        this.errorMessage = 'Failed to initiate MFA setup. Please try again.';
      }
    });
  }

  onOtpInput(event: any): void {
    const value = event.target.value;
    if (/^\d*$/.test(value) && value.length <= 6) {
      this.otp = value;
    } else {
      event.preventDefault();
    }
  }

  verifyAndEnableMfa(): void {
    if (!this.setupDetails || !this.otp) {
      return;
    }
    
    if (this.otp.length !== 6) {
      this.errorMessage = 'Please enter a valid 6-digit code';
      return;
    }
    
    this.errorMessage = null;

    const payload = {
      email: this.currentUserEmail,
      token: this.otp,
      secret: this.setupDetails.secret
    };

    this.apiService.postData('/partners/auth/totp-mfa/verify-setup', payload).subscribe(res => {
      if (res && !res.error) {
        this.isMfaEnabled = true;
        this.cancelMfaSetup();
        const user = this.authService.getUser();
        if (user && res.data) {
          Object.assign(user, res.data);
          this.authService.setUser(user);
        }
      } else {
        this.errorMessage = res.message || 'Invalid token. Please try again.';
      }
    });
  }

  disableMfa(): void {
    this.errorMessage = null;
    this.apiService.postData('/partners/auth/totp-mfa/disable', { email: this.currentUserEmail }).subscribe(res => {
      if (res && !res.error) {
        this.isMfaEnabled = false;
      } else {
        this.errorMessage = 'Failed to disable MFA. Please try again.';
      }
    });
  }

  cancelMfaSetup(): void {
    this.setupDetails = null;
    this.otp = '';
    this.errorMessage = null;
  }
}